import Component from "../qlib/Component";
import SimpleComponentRegistery from "../qlib/SimpleComponentRegistery";

/**
 * @export
 * @class PostManagerComponent
 * @extends Component
 */
export default class PostManagerComponent extends Component
{
    constructor(element)
    {
        super(element)

        // Older browser. No support. Do nothing
        if (!('IntersectionObserver' in window)) {
            return;
        }

        this.observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => this.observerCallback(entry))
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0.50
        })

        this.url = this.element.dataset.hasOwnProperty('url') ? this.element.dataset.url : null;

        this.currently_observing = element.querySelector('.js-autofill-card:nth-last-child(2)')
        if (this.currently_observing === null) return;
        this.observer.observe(this.currently_observing)

        let elements_to_hide = document.querySelectorAll('.js-autofill-hide')
        elements_to_hide.forEach((hide_e) => {
            hide_e.classList.add('d-none')
        });

        this.page = this.element.dataset.hasOwnProperty('page') ? this.element.dataset.page : 1;
        this.pagevar = this.element.dataset.hasOwnProperty('pagevar') ? this.element.dataset.pagevar : 'pagina';
    }

    observerCallback(entry)
    {
        let that = this;

        if (entry.intersectionRatio === 0) return;

        that.observer.unobserve(that.currently_observing)

        // Zero based numbering....
        that.page++;

        // let page = 0 + Math.floor(that.element.children.length / 12)
        // if (page < 1) {
        //     return;
        // }

        // let original_html = that.element.innerHTML;

        let loader_template;

        let template_element = document.querySelector('#autofill-template');
        if (template_element) {
            loader_template = template_element.content.cloneNode(true);
        } else {
            loader_template = document.createRange().createContextualFragment(
                '<div class="card hover-shadow js-autofill-loader">' +
                    '<div class="d-flex justify-content-center">' +
                      '<div class="spinner-border" role="status">' +
                        '<span class="sr-only">Loading...</span>' +
                      '</div>' +
                    '</div>' +
                '</div>'
            );
        }


        // [1,2,3].forEach(function(i) {
            that.element.appendChild(loader_template);
        // });


        setTimeout(function(){
            let url = that.url;

            if (!url) {
                url = window.location.href;
            }

            // Has hash in url, remove it
            if (url.includes('#')) {
                url = url.split('#')[0];
            }

            // Always remove autocompletepage history.back fix in new AJAX
            // requests to prevent duplicate results
            if (url.includes('autocompletepage')) {
               url = url.replace(/[\?&]autocompletepage=\d+/gi, '');
            }

            if (!url.includes('?')) {
                url += '?autocompletecall=1';
            }
            url += `&${that.pagevar}=${that.page}&output=minimal`;


            fetch(url)
                .then(res => {
                    if (res.status !== 200) {
                        that.element.removeChild(that.element.querySelector('.js-autofill-loader'));

                        let elements_to_unhide = document.querySelectorAll('.js-autofill-unhide')
                        elements_to_unhide.forEach((hide_e) => {
                            hide_e.classList.remove('d-none')
                        });
                        return;
                    }

                    return res.text()

                })
                .then(text => {
                    if (!text) return;

                    that.element.removeChild(that.element.querySelector('.js-autofill-loader'));

                    let fragment = document.createRange().createContextualFragment(text);

                    // Quickfix carousel events
                    $(fragment.querySelectorAll('.carousel')).carousel();
                    window.addQblCarouselEvents(fragment);

                    // Add all component events
                    SimpleComponentRegistery.queryElement(fragment);

                    // Add fragment to DOM
                    that.element.appendChild(fragment);

                    that.currently_observing = that.element.querySelector('.js-autofill-card:nth-last-child(2)')
                    if (that.currently_observing === null) return;

                    // Give browser some time to render above html before adding observer
                    // setTimeout(function(){
                        that.observer.observe(that.currently_observing);
                    // }, 1000);


                    if (history.pushState) {
                        // Push history state with extra page
                        let autocompletepageUrl = window.location.href;
                        if (autocompletepageUrl.includes('autocompletepage')) {
                           autocompletepageUrl = autocompletepageUrl.replace(/autocompletepage=\d+/gi, 'autocompletepage='+that.page);
                        }
                        else if (!autocompletepageUrl.includes('?')) {
                            autocompletepageUrl += '?autocompletepage='+that.page;
                        } else {
                            autocompletepageUrl += '&autocompletepage='+that.page;
                        }

                        history.pushState({
                            page: that.page
                        }, window.title, autocompletepageUrl);
                    }

                    if (lazyLoadInstance) {
                        lazyLoadInstance.update();
                    }

                })
                .catch(err => {})
        }, 1000);

    }
}

SimpleComponentRegistery.register("autoposts", PostManagerComponent)